import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "./pages/Register";
import Login from "./pages/Login";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Analytics from "./dashboard/Analytics";
import Layout from "./dashboard/Layout";
import Dashboard from "./dashboard/Dashboard";
import { useContext, useEffect } from "react";
import StateContext from "./context/state/StateContext";
import Clients from "./dashboard/Clients";
import Employees from "./dashboard/Employees";
import UserContext from "./context/user/UserContext";
import Setting from "./dashboard/Setting";
import Modal from "./components/Modal";
import Forgot from "./pages/Forgot";
import ForgotPassword from "./pages/ForgotPassword";
import Profile from "./dashboard/Profile";
import Group from "./dashboard/Group";
import AdminRegister from "./pages/AdminRegister";
import io from "socket.io-client";
import Chatbot from "./dashboard/Chatbot";
import Requests from "./dashboard/Requests";
import Agencies from "./dashboard/Agencies";
import AgencyRequests from "./pages/AgencyRequests";

function App() {
  const { getUser, fetchNotifications } = useContext(UserContext);
  const { user, getTickets, getRequests } = useContext(UserContext);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      getUser();
    }
  }, [token]);

  useEffect(() => {
    const socket = io(process.env.REACT_APP_API_URL, {
      transports: ["websocket", "polling"],
      reconnectionAttempts: 5, // Try to reconnect 5 times
      reconnectionDelay: 2000, // Wait 2 seconds between reconnections
      timeout: 10000, // Set connection timeout
    });
    // Register the user with the backend WebSocket
    const showNotification = (title, body) => {
      if (Notification.permission === "granted") {
        const notification = new Notification(title, {
          body: body,
          icon: "/images/logo-w.png", // Replace with your icon URL
          vibrate: [200, 100, 200],
        });
        // Handle click on the notification
        notification.onclick = () => {
          window.focus(); // Focus the browser window on notification click
        };
      }
    };
    if (
      Notification.permission === "default" ||
      Notification.permission !== "granted"
    ) {
      Notification.requestPermission();
    }

    // Listen for WebSocket-level errors and closure
    socket.io.engine.on("close", () => {
      console.warn("WebSocket closed before connection established");
      setTimeout(() => {
        window.location.reload();
      }, 10000); // Optional delay for reconnection attempts
    });

    socket.io.engine.on("error", (err) => {
      console.error("WebSocket error:", err);
      setTimeout(() => {
        window.location.reload();
      }, 10000); // Optional delay for reconnection attempts
    });

    socket.on("badRequest", (message) => {
      console.error("Bad Request:", message);
      setTimeout(() => {
        window.location.reload(); // Reload the page on connection error
      }, 10000); // Optional delay for reconnection attempts
    });
    socket.on("disconnect", () => {
      console.warn("Socket disconnected");
      setTimeout(() => {
        window.location.reload(); // Reload the page on connection error
      }, 10000); // Optional delay for reconnection attempts
    });

    socket.on("connect_error", (error) => {
      console.log("Connection Error:", error.message);
      setTimeout(() => {
        window.location.reload(); // Reload the page on connection error
      }, 10000); // Optional delay for reconnection attempts
    });

    socket.emit("registerUser", user.id);
    socket.on("newTask", (task) => {
      const title = "New task assigned";
      const body = `New task assigned: ${task.title}`;
      getTickets();
      fetchNotifications();
      toast.success(body);
      showNotification(title, body);
    });

    socket.on("updateTask", (task) => {
      const title = "Task Updated";
      const body = `Your Task ${task.title} is Updated`;
      getTickets();
      fetchNotifications();
      toast.success(body);
      showNotification(title, body);
    });

    socket.on("note", (notification) => {
      getTickets();
      getRequests();
      fetchNotifications();
      toast.success(notification.body);
      showNotification(notification.title, notification.body);
    });

    socket.on("deleteTask", (task) => {
      getTickets();
      fetchNotifications();
      const title = "Task Deleted";
      const body = `Task: ${task.title} has been Deleted`;
      toast.success(body);
      showNotification(title, body);
    });

    socket.on("newRequest", (request) => {
      const title = "New Request Generated";
      const body = `New Request Generated: ${request.title}`;
      getRequests();
      toast.success(body);
      showNotification(title, body);
    });
    
    // Clean up the socket on component unmount
    return () => {
      socket.off("newTask");
      socket.off("updateTask");
      socket.off("note");
      socket.off("deleteTask");
      socket.off("badRequest");
      socket.off("disconnect");
      socket.off("connect_error");
      socket.io.engine.off("close");
      socket.io.engine.off("error");
    };
  }, [user.id]);
    
  
  return (
    <>
      <Router>
        <Modal />
        <ToastContainer />
        <Routes>
          <Route index path="/" element={<Login />} />
          {/* <Route exact path='/forgot' element={<Forgot />} />
          <Route exact path='/forgot-password/:id' element={<ForgotPassword />} /> */}
          <Route exact path="/register-admin" element={<AdminRegister />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/dashboard" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route index path="requests" element={<AgencyRequests />} />
            <Route exact path="group" element={<Group />} />
            <Route exact path="analytics" element={<Analytics />} />
            <Route exact path="employees" element={<Employees />} />
            <Route exact path="chatbot" element={<Chatbot />} />
            <Route exact path="agencies" element={<Agencies />} />
            <Route exact path="support" element={<Requests />} />
            <Route exact path="setting" element={<Setting />}>
              <Route exact path="profile" element={<Profile />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
// rebuild Sat Mar  7 09:54:42 UTC 2026
